<template>
  <div>
    <v-navigation-drawer
      v-model="drawer"
      app
      temporary
      :color="color"
      dark
    >
      <v-list>
        <v-list-item>
          <v-list-item-avatar>
            <img src="@/assets/img/david_logo2.png" alt="Logo"/>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-subtitle>        
              Szerviz
            </v-list-item-subtitle>
            <v-list-item-subtitle>        
              +36 70 670 2226 
            </v-list-item-subtitle>
            <v-list-item-subtitle>        
              vendz97618@gmail.com
            </v-list-item-subtitle>
            <v-list-item-subtitle class="mt-5">        
              Autófólia
            </v-list-item-subtitle>
            <v-list-item-subtitle>        
              +36 20 584 3045
            </v-list-item-subtitle>
            <v-list-item-subtitle>        
              andifolia5@gmail.com
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <v-divider />

      <v-list dense>
        <v-list-item
          v-for="([icon, text, link], i) in items"
          :key="i"
          link
          @click="$vuetify.goTo(link)"
        >
          <v-list-item-icon class="justify-center">
            <v-icon>{{ icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="subtitile-1">{{
              text
            }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar
      app
      :color="color"
      :flat="flat"
      dark
      class="px-15"
      :class="{ expand: flat }"
    >
      <v-img class="ownlogo mr-10" max-width="75px" src="@/assets/img/david_logo2.png"/>

      <div v-if="!isXs" class="contact-info">
        <h4>Szerviz - +36 70 670 2226 | vendz97618@gmail.com</h4>
        <h4>Autófólia - +36 20 584 3045 | andifolia5@gmail.com</h4>
      </div>

      <v-spacer />
      <v-app-bar-nav-icon
        @click.stop="drawer = !drawer"
        class="mr-4"
        v-if="isXs"
      />
      <div v-else>
        <v-btn 
          v-for="([icon, text, link], i) in items"
          :key="i"
          link
          text
          @click="$vuetify.goTo(link)"
          >
          <span class="mr-2">{{ text }}</span>
        </v-btn>
      </div>
    </v-app-bar>
  </div>
</template>

<script>
export default {
  data: () => ({
    drawer: null,
    isXs: false,
    items: [
      ["mdi-home-outline", "Bemutatkozás", "#home"],
      ["mdi-information-outline", "Szolgáltatások", "#services"],
      ["mdi-image", "Referenciamunkák", "#reference"],
      ["mdi-email-outline", "Kapcsolat", "#contact"],
    ],
  }),
  props: {
    color: String,
    flat: Boolean,
  },
  methods: {
    onResize() {
      this.isXs = window.innerWidth < 850;
    },
  },

  watch: {
    isXs(value) {
      if (!value) {
        if (this.drawer) {
          this.drawer = false;
        }
      }
    },
  },
  mounted() {
    this.onResize();
    window.addEventListener("resize", this.onResize, { passive: true });
  },
};
</script>

<style scoped>
.v-toolbar {
  transition: 0.6s;
}

.expand {
  height: 80px !important;
  padding-top: 10px;
}

.ownlogo {
  width: 50%;
  height: 50%;
  object-fit: contain;
}
.contact-info {
  display: flex;
  flex-direction: column;
}

.contact-info h4 {
  margin: 0;
  line-height: 1.3;
}
</style>